import React from 'react';
import { Flex, theme } from 'antd';

interface IconCardTitleProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  /** Icon colour; defaults to the primary colour. */
  color?: string;
  /** Optional trailing element such as a count tag. */
  extra?: React.ReactNode;
}

/**
 * Card header used across the admin pages: a coloured icon, the title and an optional count tag.
 */
export function IconCardTitle({ icon, title, color, extra }: IconCardTitleProps) {
  const { token } = theme.useToken();

  return (
    <Flex align="center" gap={token.marginXS} style={{ minWidth: 0 }}>
      <span style={{ color: color ?? token.colorPrimary, display: 'inline-flex' }}>{icon}</span>
      <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</span>
      {extra}
    </Flex>
  );
}

export default IconCardTitle;
